import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Account } from './account';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private http: HttpClient) {}

  findAll(params: HttpParams): Observable<any> {
    const url = `${environment.url.api}/a/accounts`;
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  existByEmail(email: string): Observable<any> {
    const url = `${environment.url.api}/validations/accounts/exist`;
    return this.http.get<Account>(url, { params: new HttpParams().set('email', email) }).pipe(timeout(environment.config.apiWaitingTime));
  }

  findOne(id: string): Observable<any> {
    const url = `${environment.url.api}/a/accounts/${id}`;
    return this.http.get<Account>(url).pipe(timeout(environment.config.apiWaitingTime));
  }

  findByEmail(email: string): Observable<any> {
    const url = `${environment.url.api}/a/accounts/email`;
    return this.http.post<Account>(url, email).pipe(timeout(environment.config.apiWaitingTime));
  }

  create(account: Account): Observable<any> {
    const url = `${environment.url.api}/a/accounts`;
    return this.http.post<Account>(url, account).pipe(timeout(environment.config.apiWaitingTime));
  }

  save(account: Account): Observable<any> {
    const url = `${environment.url.api}/a/accounts/${account.id}`;
    return this.http.put<Account>(url, account).pipe(timeout(environment.config.apiWaitingTime));
  }

  delete(id: string): Observable<any> {
    const url = `${environment.url.api}/a/accounts/${id}`;
    return this.http.delete<Account>(url).pipe(timeout(environment.config.apiWaitingTime));
  }
}
